import './partner-import-dialog-wrapper.scss'
import {ImportedContactsDialog} from "../../imported-contacts-dialog";
import {ReportLog} from "../../../../../model/ReportLog";
import {ContactFilter} from "../../../../../../contact/model/ContactFilter";

export class PartnerImportDialogWrapper extends ImportedContactsDialog {

    static instance = (log: ReportLog) =>
        ImportedContactsDialog.instanceFactory({
            log: log,
            controller: PartnerImportDialogWrapper,
            template: require('./partner-import-dialog-wrapper.html')
        });


    constructor($mdDialog: angular.material.IDialogService) {
        super($mdDialog);
    }

    private initialFilter: Partial<ContactFilter> = {
        log: this.log
    }
}